<mat-form-field
  class="chip-list"
  appearance="outline"
  (click)="chipInputListFocus()"
>
  <mat-label>{{ chipListTitle }}</mat-label>
  <mat-chip-grid #chipList aria-label="selection" [disabled]="disabled">
    @for (item of addedItems; track item) {
      <mat-chip-row
        (removed)="remove(item)"
        selectable="true"
        removable="true"
        [disabled]="areFixedItems(item)"
      >
        {{ item }}
        <button matChipRemove>
          <mat-icon>cancel</mat-icon>
        </button>
      </mat-chip-row>
    }
    <input
      [placeholder]="placeholder"
      #chipListInput
      class="chip-list-input"
      [formControl]="chipListCtrl"
      [matAutocomplete]="auto"
      [matChipInputFor]="chipList"
      [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
      (matChipInputTokenEnd)="add($event)"
    />
  </mat-chip-grid>
  <mat-autocomplete
    #auto="matAutocomplete"
    class="chip-list-autocomplete"
    autoActiveFirstOption
    (optionSelected)="selected($event)"
  >
    @for (item of filteredItems$ | async; track item) {
      @if (!addedItems.includes(item)) {
        <mat-option [value]="item">
          <span class="item-option-content">
            <span class="item-option-text">
              {{ item }}
            </span>

            <span class="item-option-icon">
              @if (isSharedScenario(item)) {
                <div
                  [matTooltip]="itemTooltips[item]"
                  [matTooltipShowDelay]="1000"
                  [matTooltipHideDelay]="1000"
                >
                  <mat-icon class="shared-icon">group</mat-icon>
                </div>
              }
            </span>
          </span>
        </mat-option>
      }
    }
  </mat-autocomplete>
  <mat-hint>{{ hint }}</mat-hint>
  <mat-hint align="end" class="chip-list-show-error">{{
    errorMessage
  }}</mat-hint>
</mat-form-field>
